<template>
  <V2ForeignersMessaging
    v-if="$route.path.split('/').includes('messaging')"
  />
  <V2Foreigner
    v-else
  />
</template>

<script>
import V2ForeignerPageComponent from '@/views/admin/foreigners/ForeignerPageComponent.vue';
import V2ForeignersMessaging from '@/views/admin/foreigners/ForeignersMessaging.vue';

export default {
  name: 'Foreigner',
  components: {
    V2Foreigner: V2ForeignerPageComponent,
    V2ForeignersMessaging,
  },
  props: {
    fid: {
      type: Number,
      default: undefined,
    },
    pid: {
      type: Number,
      default: undefined,
    },
  },
};
</script>
